import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import 'react-table/react-table.css';
import Table from '../../common/table/TicketTable';
import {IconEdit, PrimaryIcon} from '../../common/Button';
import {debounce} from 'throttle-debounce';
import {fetchSparePartsOrdersListPageData} from '../../../actions/orders/actionSparePartsListPage';
import {Link} from 'react-router-dom';
import {moduleRoles} from '../../../utils/roles';
import {editOrderListButtonVisibility} from '../../../constants/sparePartsTicketRights';
import moment from 'moment';
import listMessages from '../../../intl/sparePartsOrders/listMessages';
import get from 'get-value';
import {domains} from '../../../constants/Utils';

const DOMAIN = domains.SPARE_PARTS;

class ListOrderTable extends React.Component {
    constructor(props) {
        super(props);
        const urlParams = new URLSearchParams(props.location.search);
        const loadedState = this.loadStateFromSessionStorage({
            listSPDefaultPageSize: 10,
            listSPDefaultSort: [{id: 'ticketNumber', desc: true}],
            listSPDefaultFilters: [],
        });

        let selectedUrlParams = []
        if(urlParams.has('status')){
            selectedUrlParams.push(
                {
                    id: 'status',
                    value: urlParams.get('status') ? urlParams.get('status') : '',
                }
            )
        }
        if(urlParams.has('group')){
            selectedUrlParams.push(
                {
                    id: 'GROUP',
                    value: urlParams.get('group').split(',')
                }
            )
        }
        if(urlParams.has('sgroup')){
            selectedUrlParams.push(
                {
                    id: 'SGROUP',
                    value: urlParams.get('sgroup').split(',')
                }
            )
        }

        if (selectedUrlParams.length > 0) {
            this.state = {
                ...loadedState,
                listSPDefaultFilters: selectedUrlParams
            }
        } else {
            this.state = {
                ...loadedState,
                listSPDefaultFilters: loadedState.listSPDefaultFilters.filter(item => !['GROUP', 'SGROUP'].includes(item.id))
            }
        }
        this.filtering = false;
        this.handleFetchData = this.handleFetchData.bind(this);
        this.handleFetchDataDebounced = debounce(1000, this.handleFetchData);
    }

    componentDidMount() {
        window.addEventListener(
            'beforeunload',
            this.saveStateToSessionStorage
        );
    }

    componentWillUnmount() {
        window.removeEventListener(
            'beforeunload',
            this.saveStateToSessionStorage
        );
        this.saveStateToSessionStorage();
    }

    loadStateFromSessionStorage(defaults) {
        return Object.keys(defaults)
            .reduce((acc, key) => {
                if (sessionStorage.hasOwnProperty(key) && key.match(/^listSP*/)) {
                    let value = sessionStorage.getItem(key);
                    value = JSON.parse(value);
                    return {
                        ...acc,
                        [key]: value,
                    };
                }
                return acc;
            }, defaults);
    }

    saveStateToSessionStorage = () => {
        for (let key in this.state) {
            if (this.state.hasOwnProperty(key) && key.match(/^listSP*/)) {
                sessionStorage.setItem(key, JSON.stringify(this.state[key]));
            }
        }
    }

    handleFetchData = state => {
        this.props.fetchSparePartsOrdersListPageData(state.pageSize, state.sorted, state.cursor, state.isNextFromPivot, this.normalizeFiltered(state));
        this.filtering = false;
        this.setState({
            listSPDefaultPageSize: state.pageSize,
            listSPDefaultSort: state.sorted,
            listSPDefaultFilters: state.filtered
        });
    };

    fetchStrategy = (state) => {
        this.filtering ? this.handleFetchDataDebounced(state) : this.handleFetchData(state);
    };

    normalizeFiltered = state => {
        return state.filtered
            .filter(filterItem => filterItem.value)
            .map(filterItem => {
                if (filterItem.value instanceof Date || filterItem.id === 'created' || filterItem.id === 'lastUpdate') {
                    return {
                        id: filterItem.id,
                        value: moment(filterItem.value).add(12, 'hours').toISOString().substr(0, 10)
                    };
                } else {
                    return filterItem;
                }
            });
    };

    render() {
        const {columns, data, pages, isLoading, handleEditClick, isNextPage, isNextFromPivot} = this.props;

        return (
            <div className="container-fluid text-center">
                <div className="row">
                    <div className="col">
                        <Table
                            columns={[
                                {
                                    id: 'ticketNumber',
                                    accessor: 'ticketNumber',
                                    message: listMessages.TABLE_TICKET_NUMBER,
                                    Cell: (row) => <Link
                                        to={`view/${row.original.uuid}`}>{row.value}</Link>,
                                },
                                ...columns]}
                            toolButtons={[
                                {
                                    handleClick: handleEditClick,
                                    component: <PrimaryIcon className="btn btn-sm"
                                                            title="Edit"
                                                            type="button"
                                                            key="editButton">
                                        <IconEdit/>
                                    </PrimaryIcon>
                                }
                            ]}
                            isLoading={isLoading}
                            data={data}
                            pages={pages}
                            handleFetchData={this.fetchStrategy}
                            handleOnFilteredChange={() => {
                                this.filtering = true;
                            }}
                            isNextPage={isNextPage}
                            isNextFromPivot={isNextFromPivot}
                            defaultFiltered={this.state.listSPDefaultFilters}
                            defaultSorting={this.state.listSPDefaultSort}
                            defaultPageSize={this.state.listSPDefaultPageSize}
                            buttonVisibility={editOrderListButtonVisibility[moduleRoles.isDealerOrder(this.props.userRoles) ? 'DEALER' : 'EDITOR']}
                            editorGroups={moduleRoles.isEditorOrder(this.props.userRoles) ? moduleRoles.getEditorGroups(domains.SPARE_PARTS, this.props.userRoles).map(e => e.group) : false}
                            sgPermissions = {get(this.props.userRoles, `${domains.SPARE_PARTS}.sgEditor.sgPermission`)}
                            checkInternationalTicketsForSGEditors
                            toolSortable={true}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

ListOrderTable.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    isNextPage: PropTypes.bool.isRequired,
    isNextFromPivot: PropTypes.bool.isRequired,
    pages: PropTypes.number.isRequired,
    fetchSparePartsOrdersListPageData: PropTypes.func.isRequired,
    columns: PropTypes.array,
    userRoles: PropTypes.object.isRequired,
    handleEditClick: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    isLoading: state.sparePartsListPage.isTableLoading,
    data: state.sparePartsListPage.listData,
    isNextPage: state.sparePartsListPage.isNextPage,
    isNextFromPivot: state.sparePartsListPage.isNextFromPivot,
    pages: state.sparePartsListPage.pages,
    userRoles: state.profile.userDetail.roles,
});

export default connect(mapStateToProps, {
    fetchSparePartsOrdersListPageData
})(ListOrderTable);
